import { GlobalConstants } from 'src/app/global-constants';
var locales = GlobalConstants.locales;
export default {
    "Daily": [
        {
            "locale": locales.ENGLISH,
            "message": "Earn daily incentives up to Rs ${totalAmount} by completing ${ordertypes} orders on ${date}. For more details click"
        },
        {
            "locale": locales.HINDI,
            "message": "${date} को ${ordertypes} ऑर्डर करें और रु ${totalAmount} रुपये तक का डेली इंसेंटिव कमाएं। अधिक जानकारी के लिए क्लिक करें"
        },
        {
            "locale": locales.KANNADA,
            "message": "${date} ರಂದು ${ordertypes} ಆರ್ಡರ್ ಪೂರ್ಣಗೊಳಿಸುವ ಮೂಲಕ ರೂ ${totalAmount} ವರೆಗೆ ಡೈಲಿ ಇನ್ಸೆಂಟಿವ್ಸ್ ಗಳಿಸಿ. ಹೆಚ್ಚಿನ ವಿವರಗಳಿಗಾಗಿ ಕ್ಲಿಕ್ ಮಾಡಿ"
        },
        {
            "locale": locales.TELUGU,
            "message": "${date} తేదీన ${ordertypes} ఆర్డర్‌లను చేయడం ద్వారా రూ. ${totalAmount} వరకు రోజువారీ ఇన్సెంటివ్‌లను పొందండి. మరిన్ని వివరాల కోసం క్లిక్ చేయండి"
        },
        {
            "locale": locales.TAMIL,
            "message": "${date} அன்று ${ordertypes} ஆர்டர் செய்வதன் மூலம் தினசரி இன்சென்டிவ் ரூ. ${totalAmount} பெறுங்கள். மேலும் விவரங்களுக்கு கிளிக் செய்யவும்"
        },
        {
            "locale": locales.BENGALI,
            "message": "${date}-এ ${ordertypes} অর্ডার দেওয়ার মাধ্যমে সর্বাধিক রুপি ${totalAmount} টাকার দৈনন্দিন ইনসেনটিভ উপার্জন করুন। আরও জানতে ক্লিক করুন"
        },
        {
            "locale": locales.MARATHI,
            "message": "${date} तारखेला ${ordertypes} ऑर्डर करा आणि रु ${totalAmount} रुपयांपर्यंत दररोज इन्सेंटिव्ह कमवा. अधिक जाणून घेण्यासाठी क्लिक करा"
        },
        {
            "locale": locales.MALAYALAM,
            "message": "${date}-ന് ${ordertypes} ഓർഡറുകൾ പൂർത്തിയാക്കൂ, ₹ ${totalAmount} വരെ പ്രതിദിന ഇൻസൻ്റീവുകൾ നേടൂ. കൂടുതൽ വിശദാംശങ്ങൾക്ക് ക്ലിക്ക് ചെയ്യൂ"
        }
    ],
    "Weekly Fixed": [
        {
            "locale": locales.ENGLISH,
            "message": "Earn weekly incentives up to Rs ${totalAmount} by completing ${ordertypes} orders on ${date}. For more details click"
        },
        {
            "locale": locales.HINDI,
            "message": "${date} को ${ordertypes} ऑर्डर पूरा करके रु ${totalAmount} तक साप्ताहिक इंसेंटिव अर्जित करें। अधिक जानकारी के लिए क्लिक करें"
        },
        {
            "locale": locales.KANNADA,
            "message": "${date} ರಂದು ${ordertypes} ಆರ್ಡರ್‌‌‌ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸುವ ಮೂಲಕ ರೂ. ${totalAmount} ವೀಕ್ಲಿ ಇನ್ಸೆಂಟಿವ್ಸ್ ಗಳಿಸಿ. ಹೆಚ್ಚಿನ ವಿವರಗಳಿಗಾಗಿ ಕ್ಲಿಕ್ ಮಾಡಿ"
        },
        {
            "locale": locales.TELUGU,
            "message": "${date} తేదీన ${ordertypes} ఆర్డర్‌లను పూర్తి చేయడం ద్వారా రూ. ${totalAmount} వరకు వారం వారీ ఇన్సెంటివ్‌లను సంపాదించండి. మరిన్ని వివరాల కోసం క్లిక్ చేయండి"
        },
        {
            "locale": locales.TAMIL,
            "message": "${date} அன்று ${ordertypes} ஆர்டரை முடிப்பதன் மூலம் ரூ ${totalAmount} வரை வீக்லி இன்சன்டிவ்களை பெறுங்கள். மேலும் விவரங்களுக்கு கிளிக் செய்யவும்"
        },
        {
            "locale": locales.BENGALI,
            "message": "${date}-এ ${ordertypes} অর্ডার সম্পূর্ণ করার মাধ্যমে সর্বাধিক রুপি ${totalAmount} সাপ্তাহিক ইনসেনটিভ উপার্জন করুন। আরও বিবরণের জন্য ক্লিক করুন"
        },
        {
            "locale": locales.MARATHI,
            "message": "${date} तारखेला ${ordertypes} ऑर्डर्स पूर्ण करण्याद्वारे ₹ ${totalAmount}पर्यंत आठवड्याला इन्सेटिंव्हची कमाई करा. अधित तपशिलासाठी क्लिक करा."
        },
        {
            "locale": locales.MALAYALAM,
            "message": "${date}-ന് ${ordertypes} ഓർഡറുകൾ പൂർത്തിയാക്കൂ, ₹ ${totalAmount} വരെ പ്രതിവാര ഇൻസൻ്റീവുകൾ നേടൂ. കൂടുതൽ വിശദാംശങ്ങൾക്ക് ക്ലിക്ക് ചെയ്യൂ"
        }
    ],
    "weeklyWithQuality": [
        {
            "locale": locales.ENGLISH,
            "message": "Earn weekly incentives up to Rs ${totalAmount} by completing ${ordertypes} orders on ${date}. Also earn Rs ${totalAmount2} extra by accepting and completing all the orders you get. For more details click"
        },
        {
            "locale": locales.HINDI,
            "message": " ${date} को ${ordertypes} ऑर्डर पूरा करके रु ${totalAmount} तक के इंसेंटिव प्राप्त करें। साथ ही सभी ऑर्डर अनुरोधों को स्वीकार करके और उन्हें पूरा करके अतिरिक्त रु ${totalAmount2} कमाएं। अधिक जानकारी के लिए क्लिक करें"
        },
        {
            "locale": locales.KANNADA,
            "message": "${date} ರಂದು ${ordertypes} ಆರ್ಡರ್‌ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸುವ ಮೂಲಕ ರೂ. ${totalAmount} ವರೆಗೆ ವೀಕ್ಲಿ ಇನ್ಸೆಂಟಿವ್ಸ್ ಗಳಿಸಿ. ನೀವು ಪಡೆಯುವ ಎಲ್ಲಾ ಆರ್ಡರ್‌‌‌‌‌‌ಗಳನ್ನು ಸ್ವೀಕರಿಸಿ, ಪೂರ್ಣಗೊಳಿಸುವ ಮೂಲಕ ಹೆಚ್ಚುವರಿಯಾಗಿ ರೂ. ${totalAmount2} ಗಳಿಸಿ. ಹೆಚ್ಚಿನ ವಿವರಗಳಿಗಾಗಿ ಕ್ಲಿಕ್ ಮಾಡಿ"
        },
        {
            "locale": locales.TELUGU,
            "message": "${date} తేదీన ${ordertypes} ఆర్డర్‌లను పూర్తి చేయడం ద్వారా రూ. ${totalAmount} వరకు వారం వారీ ఇన్సెంటివ్‌లను సంపాదించండి. మీరు పొందే ఆర్డర్‌లన్నింటినీ, పూర్తి చేయడం ద్వారా అదనంగా రూ. ${totalAmount2} సంపాదించండి. మరిన్ని వివరాల కోసం క్లిక్ చేయండి"
        },
        {
            "locale": locales.TAMIL,
            "message": "${date} அன்று ${ordertypes} ஆர்டர்களை செய்து ரூ ${totalAmount} வரை வீக்லி இன்சென்டிவ்களை பெறுங்கள். நீங்கள் பெறும் அனைத்து ஆர்டர்களையும் ஏற்று முடிப்பதன் மூலம் கூடுதலாக ரூ ${totalAmount2} சம்பாதியுங்கள். மேலும் விவரங்களுக்கு கிளிக் செய்யவும்"
        },
        {
            "locale": locales.BENGALI,
            "message": "${date}-এ ${ordertypes} অর্ডারগুলি সম্পূর্ণ করে রুপি ${totalAmount} পর্যন্ত সাপ্তাহিক ইনসেনটিভ জিতুন। এছাড়াও আপনি যে সমস্ত অর্ডার পান তা গ্রহণ করে এবং সম্পূর্ণ করে রুপি ${totalAmount2} অতিরিক্ত উপার্জন করুন। আরো বিস্তারিত জানার জন্য ক্লিক করুন"
        },
        {
            "locale": locales.MARATHI,
            "message": "${date} तारखेला ${ordertypes} ऑर्डर पूर्ण करण्याद्वारे ₹${totalAmount} पर्यंत इन्सेंटिव्ह प्राप्त करा. तसेच तुम्हाला मिळालेल्या सर्व ऑर्डरचा स्विकार आणि पूर्ण करण्याद्वारे अतिरिक्त ₹ ${totalAmount2}कमवा. अधिक माहितीसाठी क्लिक करा"
        },
        {
            "locale": locales.MALAYALAM,
            "message": "${date}-ന് ${ordertypes} ഓർഡറുകൾ പൂർത്തിയാക്കൂ, ₹ ${totalAmount} വരെ പ്രതിവാര ഇൻസൻ്റീവുകൾ നേടൂ. ഒപ്പം, നിങ്ങൾക്ക് ലഭിക്കുന്ന എല്ലാ ഓർഡറുകളും സ്വീകരിക്കുകയും പൂർത്തിയാക്കുകയും ചെയ്യുന്നതിലൂടെ ₹ ${totalAmount2} അധികം നേടാം. കൂടുതൽ വിശദാംശങ്ങൾക്ക് ക്ലിക്ക് ചെയ്യൂ"
        }
    ],
    "Adhoc": [
        {
            "locale": locales.ENGLISH,
            "message": "Earn incentives up to Rs ${totalAmount} by completing ${ordertypes} orders on ${date}. For more details click"
        },
        {
            "locale": locales.HINDI,
            "message": "${date} को ${ordertypes} ऑर्डर पूरा करके रु ${totalAmount} तक के इंसेंटिव प्राप्त करें। अधिक जानकारी के लिए क्लिक करें"
        },
        {
            "locale": locales.KANNADA,
            "message": "${date} ರಂದು ${ordertypes} ಆರ್ಡರ್‌ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸುವ ಮೂಲಕ ರೂ. ${totalAmount} ವರೆಗೆ ಇನ್ಸೆಂಟಿವ್ಸ್ ಗಳಿಸಿ. ಹೆಚ್ಚಿನ ವಿವರಗಳಿಗಾಗಿ ಕ್ಲಿಕ್ ಮಾಡಿ"
        },
        {
            "locale": locales.TELUGU,
            "message": "${date} తేదీన ${ordertypes} ఆర్డర్‌లను పూర్తి చేయడం ద్వారా రూ. ${totalAmount} వరకు ఇన్సెంటివ్‌లను సంపాదించండి. మరిన్ని వివరాల కోసం క్లిక్ చేయండి"
        },
        {
            "locale": locales.TAMIL,
            "message": "${date} அன்று ${ordertypes} ஆர்டர்களை செய்து ரூ ${totalAmount} வரை இன்சென்டிவ்களை பெறுங்கள். மேலும் விவரங்களுக்கு கிளிக் செய்யவும்"
        },
        {
            "locale": locales.BENGALI,
            "message": "${date}-এ ${ordertypes} অর্ডারের মাধ্যমে সর্বাধিক রুপি ${totalAmount} ইনসেনটিভ উপার্জন করুন। আরও জানতে ক্লিক করুন"
        },
        {
            "locale": locales.MARATHI,
            "message": "${date} तारखेला ${ordertypes} ऑर्डर पूर्ण करण्याद्वारे ₹ ${totalAmount} पर्यंत इन्सेंटिव्ह प्राप्त करा. अधिक माहितीसाठी क्लिक करा"
        },
        {
            "locale": locales.MALAYALAM,
            "message": "${date}-ന് ${ordertypes} ഓർഡറുകൾ പൂർത്തിയാക്കൂ, ₹ ${totalAmount} വരെ ഇൻസൻ്റീവുകൾ നേടൂ. കൂടുതൽ വിശദാംശങ്ങൾക്ക് ക്ലിക്ക് ചെയ്യൂ"
        }
    ]
};
//# sourceMappingURL=smsTemplates.js.map